(function () {
  'use strict';

  angular
    .module('fuelPriceReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('fuelPriceReport', {
        url: '/fuel-price-report',
        views : {
        	'fuelPriceReportView' : {
        		templateUrl: 'fuel-price-report/views/fuel-price-report.tpl.html',
                controller: 'FuelPriceReportCtrl',
                controllerAs: 'fuelPriceReport'
        	}
        }
      });
  }
}());
